import React from 'react';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  {
    key: 'formatKey',
    label: 'Format',
    required: true,
    helperText: 'The import format key this mapping applies to (e.g. "agworld").',
  },
  {
    key: 'expectedHeader',
    label: 'Expected Header',
    required: true,
    helperText: 'The column name this format’s parser normally looks for.',
  },
  {
    key: 'sourceHeader',
    label: 'Source Header',
    required: true,
    helperText: 'The actual column name found in an uploaded file.',
  },
];

// Admin view of ImportColumnMap — the "for this format, ExpectedHeader
// actually appears as SourceHeader" mappings saved once an admin confirms a
// renamed column on upload (see ImportColumnMap.cs), so future uploads of
// the same format auto-fill it instead of asking again.
const ImportColumnMapManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Import Column Map"
    icon={<ViewColumnIcon />}
    apiPath="/api/import-column-maps"
    fields={fields}
    entityLabel="Column Mapping"
    softDelete={false}
  />
);

export default ImportColumnMapManagement;
